import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { getBrands, getBrandFeatures } from '@ibe.components/booking/flights/brand/brand';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { takeWhile } from 'rxjs/operators';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { ECONOMY_BRANDS_FEATURE_MATRIX_LIST_1,
	BASIC_ANCILLARY_CODES_HAND_BAGGAGE,
	BASIC_ANCILLARY_CODES_MILES,
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_LOUNGE,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_FLIGHT_CANCELLATION,
	ECONOMY_BRANDS_FEATURE_MATRIX_LIST_2,
	BASIC_ANCILLARY_CODES_KIOSK,
	TAP_AWARD_BRANDS_FEATURE_MATRIX_LIST_1,
	TAP_AWARD_BRANDS_FEATURE_MATRIX_LIST_2,
	STAR_ALLIANCE_AWARD_BRANDS_FEATURE_MATRIX_LIST_1,
	STAR_ALLIANCE_AWARD_BRANDS_FEATURE_MATRIX_LIST_2,
	DEFAULT_LANGUAGE,
	DEFAULT_MARKET,
	SESSION_VAR_KEY_LANGUAGE,
	SESSION_VAR_KEY_MARKET,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP} from '@ibe.config';
import { getCurrencySymbol } from '@angular/common';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

@Component({
	selector: 'app-compare-fare-modal',
	templateUrl: './compare-fare-modal.indra.component.html',
	styleUrls: ['./compare-fare-modal.component.scss']
})
export class INDRACompareFareModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {
	
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	// isCorporate: boolean;

	selected_cabin = null;

	brandsList = getBrands();
	private isAlive = true;
	features;
	firstCabin = 0;
	priceUnit: string;
	flightFilter;
	hideCabin: boolean = false;
	isScrolling = false;
	// scrollingTimeout;
	availableBrands: any;
	flightFareInformation;
	loungeFootnoteID = 'lounge-footnote-oldbrands';
	changesFootnoteID = 'changes-footnote-oldbrands';
	fasttrackFootnoteID = 'fasttrack-footnote-oldbrands';
	
	@ViewChild('modal') $modal: ElementRef;

	priceUnit$: Observable<string> = this.store.select(fromStore.getOptionsBarPriceUnit);
	flightFilter$: Observable<any> = this.store.select(fromStore.getFlightsFilterState);
	flightFareInformation$: Observable<any> = this.store.select(fromStore.getFlightFareInformation);

	chargeableText;
	// feeText;
	
	constructor(
		protected modalService: ModalService,
		private store: Store<fromStore.State>,
		private ancillariesService: INDRAAncillariesService,
		private currencyService: INDRACurrencyService,
		private ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService
	) {
		super(modalService);
		this.TYPE = 'large';

		this.priceUnit$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.priceUnit = value;
		});

		this.flightFilter$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.flightFilter = value;
		});

		this.flightFareInformation$.pipe(takeWhile(() => this.isAlive)).subscribe(flightFareInformation => {
				this.flightFareInformation = flightFareInformation;
		});
		
		/* note: from post sprint 8 merge
		this.isCorporate$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(
				value => {
					this.isCorporate = value;
				}
			);
		*/
	}

	ngOnInit() {

		if (this.data && this.data.length && this.data[0].availableBrands) {
			this.brandsList = this.data[0].availableBrands;
		}
		
		this.chargeableText = this.INDRA_getTranslation('modals.compareFares.text.chargeable');
		// this.feeText = this.INDRA_getTranslation('modals.compareFares.text.fee');

		if (this.priceUnit === 'miles' && this.flightFilter.starAlliance === false) {
			this.brandsList = this.brandsList.filter((label) => label.label === 'ECONOMY / EXECUTIVE');
			this.hideCabin = true;

			const features = [];
			const features2 = [];

			for (const i in TAP_AWARD_BRANDS_FEATURE_MATRIX_LIST_1) {
				features.push(this.INDRA_mapFeatures(this.ancillariesService.getFeaturePerBrand(TAP_AWARD_BRANDS_FEATURE_MATRIX_LIST_1[i], this.flightFareInformation)));
			}

			for (const i in TAP_AWARD_BRANDS_FEATURE_MATRIX_LIST_2) {
				features2.push(this.INDRA_mapFeatures(this.ancillariesService.getFeaturePerBrand(TAP_AWARD_BRANDS_FEATURE_MATRIX_LIST_2[i], this.flightFareInformation)));
			}

			this.INDRA_selectCabin(this.data[0].brand);

            this.INDRA_removeFeature(features2);
			this.features = [features, features2];

		} else if (this.priceUnit === 'miles' && this.flightFilter.starAlliance === true) {
			this.brandsList = this.brandsList.filter((label) => label.label === 'ECONOMY / BUSINESS');
			this.hideCabin = true;
			this.INDRA_selectCabin(this.data[0].brand);

			const features = [];
			const features2 = [];

			for (const i in STAR_ALLIANCE_AWARD_BRANDS_FEATURE_MATRIX_LIST_1) {
				features.push(this.INDRA_mapFeatures(this.ancillariesService.getFeaturePerBrand(STAR_ALLIANCE_AWARD_BRANDS_FEATURE_MATRIX_LIST_1[i], this.flightFareInformation)));
			}

			for (const i in STAR_ALLIANCE_AWARD_BRANDS_FEATURE_MATRIX_LIST_2) {
				features2.push(this.INDRA_mapFeatures(this.ancillariesService.getFeaturePerBrand(STAR_ALLIANCE_AWARD_BRANDS_FEATURE_MATRIX_LIST_2[i], this.flightFareInformation)));
			}
            this.INDRA_removeFeature(features2);
			this.features = [features, features2];
			
		} else {
			this.INDRA_selectCabin(this.data[0].brand);

			for (const i in this.brandsList) {
				if (this.brandsList[i].brands.length == 0) {
					this.hideCabin = true;
					break;
				}
			}

			const features = [];
			const features2 = [];
			for (const i in ECONOMY_BRANDS_FEATURE_MATRIX_LIST_1) {
				features.push(this.INDRA_mapFeatures(this.ancillariesService.getFeaturePerBrand(ECONOMY_BRANDS_FEATURE_MATRIX_LIST_1[i], this.flightFareInformation)));
			}

			for (const i in ECONOMY_BRANDS_FEATURE_MATRIX_LIST_2) {
				features2.push(this.INDRA_mapFeatures(this.ancillariesService.getFeaturePerBrand(ECONOMY_BRANDS_FEATURE_MATRIX_LIST_2[i], this.flightFareInformation)));
			}
            this.INDRA_removeFeature(features2);
			this.features = [features, features2];
		}
	}
	
	ngOnDestroy() {
		this.isAlive = false;
	}


	INDRA_brandStyles(index) {
		const columnSize = 12 / this.brandsList[index].brands.length;
		if (this.priceUnit === 'miles') {
			const brandClass = [
				`col-${columnSize} col-tp-${columnSize} col-p-12`
			];
			return brandClass[index];
		} else {
			const brandClass = [
				`col-${columnSize} col-tp-${columnSize} col-p-12`,
				`col-${columnSize} col-tp-${columnSize} col-p-12`
			];
			return brandClass[index];
		}


	}

	/**
	 * Handles @cabin selection.
	 * Emits to parent (through an observable), that a flight was selected
	 * to close all other flight results;
	 * @param cabin {number} cabin to select
	 */
	INDRA_selectCabin(cabin: number, $event?) {
		this.selected_cabin = cabin;
	}

	/**
	 * Compares the currently selected cabin with @cabin
	 * @param cabin {string} cabin to be compared
	 */
	INDRA_isCabinSelected(cabin): boolean {
		return this.selected_cabin === cabin;
	}

	/**
	 * @returns brand state for animation based on selected_cabin
	 */
	get INDRA_brandsState(): 'expanded' | 'collapsed' {
		if (this.selected_cabin != null) {
			return 'expanded';
		} else {
			return 'collapsed';
		}
	}



	footerInfo(id): void {
		/*
		const element = document.getElementById(id);
		clearTimeout(this.scrollingTimeout);
		this.isScrolling = true;

		this.scrollingTimeout = setTimeout(() => {
			this.isScrolling = false;
		}, 1000);
		element.scrollIntoView({ block: 'start', behavior: 'smooth' });
		*/
		
		const modal: any = this.$modal.nativeElement;
		const modalPosition = modal.getBoundingClientRect().top;
		const modalScrollPosition = modal.scrollTop;

		setTimeout(() => {
			modal.scrollTo({
				left: 0,
				top: (modal.querySelector('#' + id).getBoundingClientRect().top + modalScrollPosition - modalPosition),
				behavior: 'smooth'
			});
		}, 100);
	}

	INDRA_showBrands(listIndex) {

		return this.selected_cabin === listIndex;
	}


	INDRA_mapFeatures(featureInfo: any) {
		let feature: any;
		if (this.priceUnit === 'miles' && this.flightFilter.starAlliance === false) {
			feature = {
				icon: featureInfo.icon,
				link: null,
				label: featureInfo.labelTranslationKey,
				sup: null,
				id: null,
				'miles&go-economy': null,
				'miles&go-extra': null,
				'miles&go-executive': null
			};

		} else if (this.priceUnit === 'miles' && this.flightFilter.starAlliance === true) {
			feature = {
				icon: featureInfo.icon,
				link: null,
				label: featureInfo.labelTranslationKey,
				sup: null,
				id: null,
				'star_alliance-economy': null,
				'star_alliance-business': null,
				'star_alliance-first': null
			};
		} else {
			feature = {
				icon: featureInfo.icon,
				link: null,
				label: featureInfo.labelTranslationKey,
				sup: null,
				id: null,
				discount: null,
				basic: null,
				classic: null,
				plus: null,
				executive: null,
				'top-executive': null
			};
		}

		for (const i in featureInfo.brands) {
			// FEATURE 1 - miles
			// FEATURE 2 - kiosk
			if (featureInfo.code == BASIC_ANCILLARY_CODES_MILES || featureInfo.code == BASIC_ANCILLARY_CODES_KIOSK) {
				feature[featureInfo.brands[i].name] = featureInfo.brands[i].feature.description;
			// FEATURE 1 - hand baggage, checked baggage
			} else if (featureInfo.code == BASIC_ANCILLARY_CODES_HAND_BAGGAGE
				|| featureInfo.code == BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE) {
				if (featureInfo.brands[i].feature.type == 'added') {
					feature[featureInfo.brands[i].name] = featureInfo.brands[i].feature.description;
				} else if (featureInfo.brands[i].feature.type == 'available') {
					if (featureInfo.brands[i].feature.currency || featureInfo.brands[i].feature.price > 0) {
						feature[featureInfo.brands[i].name] = this.chargeableText;
					}
				}
			// FEATURE 1 - meals, seat reservation, fast track, lounge, flight changes, cancellation
			// FEATURE 2 - checkin, boarding, priority baggage, premium baggage, premium customer center
			} else {
				if (featureInfo.brands[i].feature.type == 'added') {
					feature[featureInfo.brands[i].name] = true;
				} else if (featureInfo.brands[i].feature.type == 'unavailable') {
					feature[featureInfo.brands[i].name] = featureInfo.brands[i].feature.description;
				} else if (featureInfo.brands[i].feature.type == 'available') {
					if (featureInfo.brands[i].feature.currency || featureInfo.brands[i].feature.price > 0) {
						// if (featureInfo.code == BASIC_ANCILLARY_CODES_FLIGHT_CHANGES || featureInfo.code == BASIC_ANCILLARY_CODES_FLIGHT_CANCELLATION) {
						// 	feature[featureInfo.brands[i].name] = this.feeText + ' ' + featureInfo.brands[i].feature.price + ' ' + (this.currencyService.INDRA_getCurrencySymbol(featureInfo.brands[i].feature.currency).unit);
						// } else {
							feature[featureInfo.brands[i].name] = this.chargeableText;
						// }
					}
				}
			}

			// handle superscript
			if (featureInfo.code == BASIC_ANCILLARY_CODES_FASTTRACK) {
				feature.link = true;
				feature.sup = 2;
				feature.id = this.fasttrackFootnoteID;
			} else if (featureInfo.code == BASIC_ANCILLARY_CODES_LOUNGE) {
				feature.link = true;
				feature.sup = 3;
				feature.id = this.loungeFootnoteID;
			} else if (featureInfo.code == BASIC_ANCILLARY_CODES_FLIGHT_CHANGES) {
				feature.link = true;
				feature.sup = 1;
				feature.id = this.changesFootnoteID;
			}

		}

		return feature;
	}
	
	private INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_show(feature) {
		/* note: from post Sprint 8 merge
		if (feature) {
			if (this.isCorporate) {
				return true
			} else {
				return feature.indexOf('Corporate') < 0;
			}
		}
		*/
		return true;
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	INDRA_removeFeature(features2){
	    for(const i in features2){
            if(features2[i].label == 'ancillaries.group.KIOSK'){
                features2.splice(i, 1);
            }
        }
	}
}
